"use strict";
console.log('Mid-Hudson Works');
// Menu
jQuery('a.menu-toggle').on('click', e => {
    e.preventDefault();
    e.stopPropagation();
    jQuery('a.menu-toggle').toggleClass('open');
    jQuery('.top-bar .top-bar-right').toggleClass('open');
});
jQuery('#menu-button').on('click', e => {
    e.preventDefault();
    e.stopPropagation();
    jQuery('#menu-button').toggleClass('active');
    jQuery('.top-bar .top-bar-right').toggleClass('open');
});
function toggleEffect() {
    const profileContainer = document.getElementById('profileContainer');
    profileContainer?.classList.toggle('revealed');
}
// If a link begins with a # smooth scroll to that element
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const href = this.getAttribute('href');
        if (href) {
            const targetElement = document.querySelector(href);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });
});
const autoOwlFigureGallery = () => {
    // Check if we're on a .single-post page
    if (!document.querySelector('.single-post')) {
        return;
    }
    // The minimum number of consecutive <figure> elements to initialize the carousel
    const minFiguresForCarousel = 2;
    const figures = document.querySelectorAll('figure');
    let consecutiveFigures = [];
    let previousFigure = null;
    // Function to wrap figures into the carousel and initialize
    function createCarousel(figuresGroup) {
        const carousel = document.createElement('div');
        carousel.className = 'owl-carousel';
        // Add additional classes to the carousel
        carousel.classList.add('owl-dots-light');
        figuresGroup.forEach(function (figure) {
            carousel.appendChild(figure); // Append figure to the carousel
        });
        // Select the .entry-content div
        const entryContent = document.querySelector('.entry-content');
        // Append the carousel to the .entry-content div
        entryContent.appendChild(carousel);
        // Initialize the Owl Carousel
        jQuery(carousel).owlCarousel({
            loop: false,
            margin: 0,
            nav: true,
            lazyLoad: true,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            responsive: {
                0: { items: 2 },
                600: { items: 2 },
                1000: { items: 2 }
            }
        });
    }
    figures.forEach(function (figure, index) {
        // Check if current figure is directly after the previous figure
        if (previousFigure && figure.previousElementSibling === previousFigure) {
            consecutiveFigures.push(figure);
        }
        else {
            // Not consecutive, check if we have enough figures to create a carousel
            if (consecutiveFigures.length >= minFiguresForCarousel) {
                createCarousel(consecutiveFigures);
            }
            // Start a new group
            consecutiveFigures = [figure];
        }
        // Prepare for next iteration
        previousFigure = figure;
        // Check at the end of the loop if the remaining figures form a carousel
        if (index === figures.length - 1 && consecutiveFigures.length >= minFiguresForCarousel) {
            createCarousel(consecutiveFigures);
        }
    });
};
const parallaxVertical = () => {
    // Parallax effect
    const speed = 0.005; // Speed of parallax effect
    const elements = document.querySelectorAll('.move-with-scroll');
    if (!elements.length) {
        return;
    }
    // Inject CSS dynamically
    const css = `
    section {
        transform-style: preserve-3d;
        transform: translateZ(0);
    }
    .column {
        // transition: transform 150ms ease-in-out;
        transform: translateZ(10px);
    }
  `;
    const head = document.head;
    const style = document.createElement('style');
    head.appendChild(style);
    style.appendChild(document.createTextNode(css));
    document.addEventListener('scroll', () => {
        elements?.forEach((elem, index) => {
            const distance = window.scrollY * speed * (index + 1);
            elem.style.transform = `translateY(${-distance}px)`;
        });
    });
};
// Wait for the DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
    autoOwlFigureGallery();
    parallaxVertical();
});
